<template>
  <section class="activetime-by-typecomponent-reefere">
    <div class="activetime-by-typecomponent-reefere__header">
      <div class="activetime-by-typecomponent-reefere__header__cont-select-matchs">
        <div class="activetime-by-typecomponent-reefere__header__cont-select-matchs__label">
          Jornadas:
        </div>
        <div class="activetime-by-typecomponent-reefere__header__cont-select-matchs__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect :value="match" placeholder="Seleccione" expanded @input="onChangeMatch">
              <option v-for="match in matchdays" :key="match.id" :value="match.id">
                {{ match.name }}
              </option>
            </BSelect>
          </BField>
        </div>
      </div>
    </div>
    <div class="activetime-by-typecomponent-reefere__table">
      <BCarousel
        :key="updateSlider"
        :interval="5000"
        :autoplay="false"
        :indicator-inside="false"
        :pause-info="false"
        :progress="false"
      >
        <template v-for="(arrayPage, indexPage) in referees">
          <BCarouselItem :key="indexPage">
            <div class="table-activetime-by-type">
              <div class="table-activetime-by-type__header">
                <div class="table-activetime-by-type__header__pos">Pos</div>
                <div class="table-activetime-by-type__header__team">Arbitro</div>
                <div class="table-activetime-by-type__header__ta" @click="orderRefereeSection('ta')">
                  T.E.<img v-if="orderTA == 0" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_flecha.png" />
                  <img v-if="orderTA == 1" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_flecha2.png" />
                </div>
                <div class="table-activetime-by-type__header__ti" @click="orderRefereeSection('ti')">
                  % T.E. <img v-if="orderTI == 0" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_flecha.png" />
                  <img v-if="orderTI == 1" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_flecha2.png" />
                </div>
              </div>
              <template v-for="(item, index) in arrayPage">
                <div :key="index" class="table-activetime-by-type__row">
                  <div class="table-activetime-by-type__row__pos">{{ item.pos }}</div>
                  <div class="table-activetime-by-type__row__shield">
                    <img :src="item.logo" />
                  </div>
                  <div class="table-activetime-by-type__row__team">{{ item.name }}</div>
                  <div class="table-activetime-by-type__row__ta">{{ item.ta }}</div>
                  <div class="table-activetime-by-type__row__ti">
                    {{ item.taper }}
                  </div>
                </div>
              </template>
            </div>
          </BCarouselItem>
        </template>
      </BCarousel>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActiveTimeByTypeReefereComponent',
  components: {},
  props: {
    matchdays: {
      type: Array,
      default: () => [],
    },
    referees: {
      type: Array,
      default: () => [],
    },
    match: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { orderTA: 1, orderTI: 0, updateSlider: 0 };
  },
  methods: {
    showEmit(flag) {
      this.$emit('show', flag);
    },
    onChangeMatch(val) {
      this.$emit('onChangeMatch', val);
      this.updateSlider += 1;
    },
    orderRefereeSection(type) {
      let orderValue = 0;
      if (type == 'ta') {
        orderValue = this.orderTA;
      } else {
        orderValue = this.orderTI;
      }
      this.$emit('orderRefereeSection', { type: type, order: orderValue });
      if (type == 'ta') {
        if (this.orderTA == 0) {
          this.orderTA = 1;
        } else {
          this.orderTA = 0;
        }
      } else {
        if (this.orderTI == 0) {
          this.orderTI = 1;
        } else {
          this.orderTI = 0;
        }
      }
    },
  },
  created() {},
};
</script>
<style>
.activetime-by-typecomponent-reefere .carousel .carousel-indicator .indicator-item {
  margin-top: -49px;
}
.activetime-by-typecomponent-reefere .carousel .carousel-indicator .indicator-item .indicator-style {
  width: 12px;
  height: 4px;
  border-radius: 2px;
  background-color: #c0c0c0c7;
  border: none;
}

.activetime-by-typecomponent-reefere .carousel .carousel-indicator .indicator-item:not(:last-child) {
  margin-right: 0.1rem;
}
.activetime-by-typecomponent-reefere .carousel .carousel-indicator .indicator-item .indicator-style:hover {
  background: rgb(128, 128, 128) !important;
}
.activetime-by-typecomponent-reefere .carousel .carousel-indicator .indicator-item.is-active .indicator-style {
  background: #00a5ff;
}
.activetime-by-typecomponent-reefere .carousel .carousel-indicator.is-inside.is-bottom {
  bottom: -80px !important;
}
.activetime-by-typecomponent-reefere .carousel-arrow .icon.has-icons-right {
  right: 1% !important;
  top: 94% !important;
}
.activetime-by-typecomponent-reefere .carousel-arrow .icon.has-icons-left {
  left: 1% !important;
  top: 94% !important;
}
.activetime-by-typecomponent-reefere .carousel-arrow.is-hovered {
  opacity: 1 !important;
}
.activetime-by-typecomponent-reefere .carousel-arrow .icon {
  width: 40px;
  height: 24px;
  opacity: 0.5;
  border-radius: 6px;
  background-color: rgba(19, 40, 57, 0.4);
}
.activetime-by-typecomponent-reefere .carousel-arrow .icon:hover {
  border: 1px solid #7e7e7e;
}
.activetime-by-typecomponent-reefere .carousel-arrow .icon {
  color: white;
}
</style>
<style lang="scss" scoped>
.table-activetime-by-type {
  width: 100%;
  height: auto;
  padding-bottom: 37px;
  // background: gray;
  &__header {
    width: 100%;
    height: 28px;
    border-radius: 6px;
    background-color: #f7fafc;
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.24px;
    text-align: center;
    color: #132839;
    font-family: 'Avenir-Demi';
    &__pos {
      width: 11.7%;
      // background: rgb(51, 47, 47);
    }
    &__team {
      width: 44.32%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
    &__ta {
      width: 19.85%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
    &__ti {
      width: 19.85%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
  }
  &__row {
    width: 100%;
    height: 28px;
    // background-color: #def103;
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 28px;
    letter-spacing: -0.24px;
    text-align: center;
    color: #132839;
    &__pos {
      width: 11.7%;
      background-color: #f7fafc;
      font-size: 12px;
      height: 28px;
      font-family: 'Avenir-Demi';
      border-radius: 6px;
    }
    &__shield {
      width: 8.5%;
      margin-left: 1.71%;
      height: 28px;
      img {
        width: 24px;
      }
    }
    &__team {
      width: 34.39%;
      text-align: left !important;
      padding-left: 3%;
      margin-left: 1.71%;
      height: 28px;
      background-color: #f7fafc;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
      font-family: 'Avenir-Medium';
    }
    &__ta {
      width: 19.85%;
      margin-left: 1.71%;
      background-color: #edf4f9;
      font-size: 14px;
      height: 28px;
      border-radius: 6px;
      font-family: 'Avenir-Demi';
    }
    &__ti {
      width: 19.85%;
      margin-left: 1.71%;
      border-radius: 6px;
      height: 28px;
      background-color: #edf4f9;
      font-size: 14px;
      font-family: 'Avenir-Demi';
      &__medium {
        font-family: 'Avenir-Medium';
        font-size: 11px;
        margin-left: 1px;
      }
    }
  }
}

.activetime-by-typecomponent-reefere {
  width: 93%;
  height: 355px;
  margin: 0 auto;
  display: inline-block;
  &__header {
    width: 100%;
    height: 32px;
    &__cont-select-matchs {
      width: 100%;
      height: 56px;
      margin-top: 8px;
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        padding-left: 2px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
      }
    }
  }
  &__table {
    width: 100%;
    height: 268px;
    margin-top: 40px;
    // background: palevioletred;
  }
}
</style>
